import type { FeedbackEntry } from '@/bindings/FeedbackEntry'
import type { Translate } from '@/lib/i18n/translate'

const str = (value: unknown) => (typeof value === 'string' ? value : '')

/** What a row is about, from its snapshots: the order, the branch, the restaurant, or the page. */
export function describeFeedback({ target, params }: Pick<FeedbackEntry, 'target' | 'params'>, t: Translate): string {
  if (target === 'app') {
    const path = str(params.path)
    return path ? t('feedback.about.page', { path }) : t('feedback.about.app')
  }
  const branch = str(params.branch_name)
  if (typeof params.order_number === 'number') {
    const order = t('feedback.about.order', { number: params.order_number })
    return branch ? `${order} · ${branch}` : order
  }
  return branch ? t('feedback.about.branch', { name: branch }) : t('feedback.about.restaurant')
}
